var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 17.5,
    width: 17,
    height: 3.63636,
    rx: 0.909091,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31995,
    y: 9,
    width: 2.75,
    height: 7.5,
    rx: 0.909091,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5699,
    y: 9,
    width: 2.75,
    height: 7.5,
    rx: 0.909091,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8199,
    y: 9,
    width: 2.75,
    height: 7.5,
    rx: 0.909091,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6078 2.68759C11.8558 2.56896 12.1442 2.56896 12.3922 2.68759L19.8844 6.27079C20.7576 6.68842 20.4601 8 19.4921 8H4.50786C3.53989 8 3.24239 6.68842 4.11563 6.27079L11.6078 2.68759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/Bank Icon.2459477016c6a689755ea40f3e45c6fd.svg";
export { ForwardRef as ReactComponent };